(() => {
  function initPackBuilderV2(root) {
    if (!root || root.dataset.packBuilderV2Ready === "true") return;
    root.dataset.packBuilderV2Ready = "true";

    const jsonEl = root.querySelector("[data-pbv2-products-json]");
    const currentImageEl = root.querySelector("[data-pbv2-current-image]");
    const currentTitleEl = root.querySelector("[data-pbv2-current-title]");
    const currentPriceEl = root.querySelector("[data-pbv2-current-price]");
    const currentOptionsEl = root.querySelector("[data-pbv2-current-options]");
    const currentSizesEl = root.querySelector("[data-pbv2-current-sizes]");
    const currentStylesEl = root.querySelector("[data-pbv2-current-styles]");

    const addonImageEl = root.querySelector("[data-pbv2-addon-image]");
    const addonTitleEl = root.querySelector("[data-pbv2-addon-title]");
    const addonPriceEl = root.querySelector("[data-pbv2-addon-price]");
    const addonProductsEl = root.querySelector("[data-pbv2-addon-products]");
    const addonColorsEl = root.querySelector("[data-pbv2-addon-colors]");
    const addonSizesEl = root.querySelector("[data-pbv2-addon-sizes]");

    const salePriceEl = root.querySelector("[data-pbv2-sale-price]");
    const comparePriceEl = root.querySelector("[data-pbv2-compare-price]");
    const saveBadgeEl = root.querySelector("[data-pbv2-save-badge]");
    const atcPriceEl = root.querySelector("[data-pbv2-atc-price]");
    const atc = root.querySelector("[data-pbv2-atc]");
    const stockEl = root.querySelector("[data-pbv2-stock]");
    const errorEl = root.querySelector("[data-pbv2-error]");

    const bundleName = root.dataset.bundleName || "Bundle & Save";
    const sizeOptionName = root.dataset.sizeOptionName || "Size";
    const colorOptionName = root.dataset.colorOptionName || "Color";
    const discountPercent = Number(root.dataset.discountPercent || 0);
    const fixedSalePrice = Number(root.dataset.fixedSalePrice || 0);

    let data = {
      currentProduct: null,
      addonProducts: []
    };

    let selectedCurrentVariant = null;
    let selectedAddonProduct = null;
    let selectedAddonVariant = null;
    let selectedAddonColor = "";
    let selectedAddonSize = "";

    try {
      data = JSON.parse(jsonEl?.textContent || "{}");
    } catch (error) {
      console.error("Pack Builder V2 JSON error:", error);
      return;
    }

    function money(cents) {
      const amount = Number(cents || 0) / 100;
      const currencyCode = root.dataset.currencyCode || "USD";

      try {
        return new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: currencyCode,
          currencyDisplay: "narrowSymbol"
        }).format(amount);
      } catch (error) {
        return new Intl.NumberFormat(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount) + " " + currencyCode;
      }
    }

    function discountedPrice(cents) {
      const price = Number(cents || 0);

      if (fixedSalePrice > 0) {
        const totalOriginal =
          Number(selectedCurrentVariant?.price || 0) +
          Number(selectedAddonVariant?.price || 0);

        if (totalOriginal <= 0) return price;

        return Math.ceil(price * fixedSalePrice / totalOriginal);
      }

      if (discountPercent > 0) {
        return Math.ceil(price * (100 - discountPercent) / 100);
      }

      return price;
    }

    function priceHtml(originalCents) {
      const original = Number(originalCents || 0);
      const discounted = discountedPrice(original);

      if (discounted < original) {
        return `
          <span class="pack-builder-v2-line-price__compare">${money(original)}</span>
          <span class="pack-builder-v2-line-price__sale">${money(discounted)}</span>
        `;
      }

      return `<span class="pack-builder-v2-line-price__sale">${money(original)}</span>`;
    }

    function makeBundleId() {
      const a = Math.random().toString(36).slice(2, 10).toUpperCase();
      const b = Date.now().toString(36).slice(-8).toUpperCase();
      return `PBV2-${a}${b}`;
    }

    function unique(values) {
      return [...new Set(values.filter(Boolean))];
    }

    function getVariantSize(variant) {
      return variant?.options?.[sizeOptionName] || "";
    }

    function getVariantColor(variant) {
      return variant?.options?.[colorOptionName] || "";
    }

    function getMainProductForm() {
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));

      for (const form of forms) {
        if (!root.contains(form)) return form;
      }

      return null;
    }

    function getMainVariantInput() {
      const form = getMainProductForm();

      return form?.querySelector('input[name="id"], select[name="id"]') ||
        document.querySelector('input[name="id"], select[name="id"]');
    }

    function getMainVariantId() {
      const input = getMainVariantInput();

      if (input && input.value) return String(input.value);

      const params = new URLSearchParams(window.location.search);
      const variantFromUrl = params.get("variant");

      if (variantFromUrl) return String(variantFromUrl);

      return String(data.currentProduct?.selectedVariantId || "");
    }

    function getCurrentVariantFromMainProduct() {
      const variantId = getMainVariantId();

      return data.currentProduct?.variants?.find((variant) => {
        return String(variant.id) === String(variantId);
      }) ||
      data.currentProduct?.variants?.find((variant) => variant.available) ||
      data.currentProduct?.variants?.[0] ||
      null;
    }

    function clickMainProductSize(size) {
      if (!size) return false;

      const possibleInputs = Array.from(document.querySelectorAll('input[type="radio"]')).filter((input) => {
        if (root.contains(input)) return false;
        return String(input.value).trim() === String(size).trim();
      });

      const sizeInput = possibleInputs[0];

      if (!sizeInput) return false;

      sizeInput.click();
      sizeInput.dispatchEvent(new Event("change", { bubbles: true }));

      return true;
    }

    function findVariantByOptions(product, options) {
      if (!product || !Array.isArray(product.variants)) return null;

      return product.variants.find((variant) => {
        if (!variant.options) return false;

        return Object.keys(options).every((optionName) => {
          if (!options[optionName]) return true;
          return variant.options[optionName] === options[optionName];
        });
      }) || null;
    }

    function findAddonVariant(product, color, size) {
      if (!product || !Array.isArray(product.variants)) return null;

      const hasColor = product.variants.some((variant) => {
        return variant.options && Object.prototype.hasOwnProperty.call(variant.options, colorOptionName);
      });

      const hasSize = product.variants.some((variant) => {
        return variant.options && Object.prototype.hasOwnProperty.call(variant.options, sizeOptionName);
      });

      const options = {};

      if (hasColor && color) options[colorOptionName] = color;
      if (hasSize && size) options[sizeOptionName] = size;

      return findVariantByOptions(product, options) ||
        product.variants.find((variant) => variant.available) ||
        product.variants[0] ||
        null;
    }

    function getProductImage(product, variant) {
      return variant?.image || product?.image || "";
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = "";
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function renderCurrentItem() {
      selectedCurrentVariant = getCurrentVariantFromMainProduct();

      if (!selectedCurrentVariant || !data.currentProduct) return;

      if (currentImageEl) {
        currentImageEl.src = selectedCurrentVariant.image || data.currentProduct.featuredImage || "";
        currentImageEl.alt = data.currentProduct.title || "";
      }

      if (currentTitleEl) {
        currentTitleEl.textContent = data.currentProduct.title || "";
      }

      if (currentPriceEl) {
        currentPriceEl.innerHTML = priceHtml(selectedCurrentVariant.price);
      }

      if (currentOptionsEl) {
        currentOptionsEl.innerHTML = "";
      }

      renderCurrentSizes();
    }


    function renderCurrentSizes() {
      if (!currentSizesEl || !data.currentProduct) return;

      const selectedSize = getVariantSize(selectedCurrentVariant);
      const sizes = unique(data.currentProduct.variants.map(getVariantSize));

      currentSizesEl.innerHTML = "";

      sizes.forEach((size) => {
        const matchingVariant = findVariantByOptions(data.currentProduct, {
          [sizeOptionName]: size
        });

        const button = document.createElement("button");
        button.type = "button";
        button.className = "pack-builder-v2-size";
        button.textContent = size;
        button.disabled = !matchingVariant || !matchingVariant.available;
        button.classList.toggle("is-selected", size === selectedSize);

        button.addEventListener("click", (event) => {
          event.preventDefault();

          if (!matchingVariant || !matchingVariant.available) return;

          selectedCurrentVariant = matchingVariant;

          const mainVariantPicker =
            document.querySelector('variant-picker[context="main_product"]') ||
            document.querySelector('variant-picker');

          let clickedRealPicker = false;

          if (mainVariantPicker) {
            const realLabels = Array.from(mainVariantPicker.querySelectorAll("label.block-swatch"));

            const realLabel = realLabels.find((label) => {
              const labelText = label.textContent.trim();
              return labelText === String(size).trim();
            });

            if (realLabel) {
              realLabel.click();
              clickedRealPicker = true;

              const realInputId = realLabel.getAttribute("for");
              const realInput = realInputId ? document.getElementById(realInputId) : null;

              if (realInput) {
                realInput.checked = true;
                realInput.dispatchEvent(new Event("input", { bubbles: true }));
                realInput.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
          }

          if (!clickedRealPicker) {
            const mainVariantInput =
              document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
              document.querySelector('form[action*="/cart/add"] select[name="id"]');

            if (mainVariantInput) {
              mainVariantInput.value = matchingVariant.id;
              mainVariantInput.dispatchEvent(new Event("input", { bubbles: true }));
              mainVariantInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }

          window.setTimeout(() => {
            selectedCurrentVariant = getCurrentVariantFromMainProduct() || matchingVariant;

            renderCurrentItem();
            syncAddonSizeWithCurrent();
            renderAddonSizes();
            updateAddonVariant();
            updatePrices();
            updateAtcState();
            clearError();
          }, 150);

          window.setTimeout(() => {
            selectedCurrentVariant = getCurrentVariantFromMainProduct() || matchingVariant;

            renderCurrentItem();
            syncAddonSizeWithCurrent();
            renderAddonSizes();
            updateAddonVariant();
            updatePrices();
            updateAtcState();
            clearError();
          }, 400);
        });

        currentSizesEl.appendChild(button);
      });
    }





    function renderAddonProducts() {
      if (!addonProductsEl) return;

      addonProductsEl.innerHTML = "";

      data.addonProducts.forEach((product, index) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "pack-builder-v2-swatch";
        button.title = product.title;
        button.setAttribute("aria-label", product.title);

        const swatch = document.createElement("span");
        swatch.style.backgroundImage = `url("${product.swatch || product.image || ""}")`;
        button.appendChild(swatch);

        button.addEventListener("click", () => {
          selectedAddonProduct = product;

          const firstAvailable = product.variants.find((variant) => variant.available) || product.variants[0];
          selectedAddonColor = getVariantColor(firstAvailable);
          selectedAddonSize = getVariantSize(selectedCurrentVariant) || getVariantSize(firstAvailable);

          addonProductsEl.querySelectorAll(".pack-builder-v2-swatch").forEach((other) => {
            other.classList.remove("is-selected");
          });

          button.classList.add("is-selected");

          renderAddonColors();
          renderAddonSizes();
          updateAddonVariant();
          updatePrices();
          updateAtcState();
        });

        addonProductsEl.appendChild(button);

        if (index === 0) {
          button.click();
        }
      });
    }

    function renderAddonColors() {
      if (!addonColorsEl || !selectedAddonProduct) return;

      const colors = unique(selectedAddonProduct.variants.map(getVariantColor));

      addonColorsEl.innerHTML = "";

      if (!colors.length) {
        addonColorsEl.hidden = true;
        return;
      }

      addonColorsEl.hidden = false;

      colors.forEach((color) => {
        const variant = findVariantByOptions(selectedAddonProduct, {
          [colorOptionName]: color
        });

        const button = document.createElement("button");
        button.type = "button";
        button.className = "pack-builder-v2-color";
        button.title = color;
        button.setAttribute("aria-label", color);
        button.classList.toggle("is-selected", color === selectedAddonColor);

        const swatch = document.createElement("span");
        swatch.style.backgroundImage = `url("${variant?.image || selectedAddonProduct.swatch || selectedAddonProduct.image || ""}")`;
        button.appendChild(swatch);

        button.addEventListener("click", () => {
          selectedAddonColor = color;

          renderAddonColors();
          renderAddonSizes();
          updateAddonVariant();
          updatePrices();
          updateAtcState();
        });

        addonColorsEl.appendChild(button);
      });
    }

    function syncAddonSizeWithCurrent() {
      const currentSize = getVariantSize(selectedCurrentVariant);

      if (!selectedAddonProduct || !currentSize) return;

      const matchingAddonVariant = findAddonVariant(selectedAddonProduct, selectedAddonColor, currentSize);

      if (matchingAddonVariant) {
        selectedAddonSize = currentSize;
      }
    }

    function renderAddonSizes() {
      if (!addonSizesEl || !selectedAddonProduct) return;

      const sizes = unique(selectedAddonProduct.variants.map(getVariantSize));

      addonSizesEl.innerHTML = "";

      sizes.forEach((size) => {
        const variant = findAddonVariant(selectedAddonProduct, selectedAddonColor, size);

        const button = document.createElement("button");
        button.type = "button";
        button.className = "pack-builder-v2-size";
        button.textContent = size;
        button.disabled = !variant || !variant.available;
        button.classList.toggle("is-selected", size === selectedAddonSize);

        button.addEventListener("click", (event) => {
          event.preventDefault();

          selectedAddonSize = size;

          renderAddonSizes();
          updateAddonVariant();
          updatePrices();
          updateAtcState();
        });

        addonSizesEl.appendChild(button);
      });
    }

    function updateAddonVariant() {
      if (!selectedAddonProduct) return;

      selectedAddonVariant = findAddonVariant(selectedAddonProduct, selectedAddonColor, selectedAddonSize);

      if (!selectedAddonVariant) return;

      if (addonImageEl) {
        addonImageEl.src = getProductImage(selectedAddonProduct, selectedAddonVariant);
        addonImageEl.alt = selectedAddonProduct.title || "";
        addonImageEl.hidden = false;
      }

      if (addonTitleEl) {
        addonTitleEl.textContent = selectedAddonProduct.title || "";
      }

      if (addonPriceEl) {
        addonPriceEl.innerHTML = priceHtml(selectedAddonVariant.price);
      }
    }

    function calculatePrices() {
      const currentPrice = Number(selectedCurrentVariant?.price || 0);
      const addonPrice = Number(selectedAddonVariant?.price || 0);
      const compareCents = currentPrice + addonPrice;

      let saleCents = compareCents;

      if (fixedSalePrice > 0) {
        saleCents = fixedSalePrice;
      } else if (discountPercent > 0) {
        saleCents = Math.ceil(currentPrice * (100 - discountPercent) / 100) +
          Math.ceil(addonPrice * (100 - discountPercent) / 100);
      }

      return {
        compareCents,
        saleCents,
        saveCents: Math.max(compareCents - saleCents, 0)
      };
    }

    function updatePrices() {
      const prices = calculatePrices();

      if (salePriceEl) {
        salePriceEl.textContent = prices.saleCents > 0 ? money(prices.saleCents) : "";
      }

      if (comparePriceEl) {
        comparePriceEl.hidden = !(prices.compareCents > prices.saleCents);
        comparePriceEl.textContent = money(prices.compareCents);
      }

      if (saveBadgeEl) {
        saveBadgeEl.hidden = !(prices.saveCents > 0);
        saveBadgeEl.textContent = `Save ${money(prices.saveCents)}`;
      }

      if (atcPriceEl) {
        atcPriceEl.textContent = prices.saleCents > 0 ? `• ${money(prices.saleCents)}` : "";
      }
    }

    function updateAtcState() {
      const ready =
        selectedCurrentVariant &&
        selectedCurrentVariant.available &&
        selectedAddonVariant &&
        selectedAddonVariant.available;

      if (atc) {
        atc.disabled = !ready;
      }

      if (stockEl) {
        stockEl.textContent = ready ? "In stock: ready to ship" : "";
      }
    }

    async function addBundleToCart() {
      clearError();

      if (!selectedCurrentVariant || !selectedCurrentVariant.available) {
        showError("Select an available main product variant.");
        return;
      }

      if (!selectedAddonVariant || !selectedAddonVariant.available) {
        showError("Select an available bundle item.");
        return;
      }

      const prices = calculatePrices();
      const bundleId = makeBundleId();
      const baseSize = getVariantSize(selectedCurrentVariant);

      const items = [
        {
          id: selectedCurrentVariant.id,
          quantity: 1,
          properties: {
            "_bundle_id": bundleId,
            "_bundle_name": bundleName,
            "_bundle_type": "product-page-bundle-v2",
            "_bundle_role": "base",
            "_bundle_slot": "1",
            "_bundle_size": baseSize,
            "_bundle_discount_percent": String(discountPercent)
          }
        },
        {
          id: selectedAddonVariant.id,
          quantity: 1,
          properties: {
            "_bundle_id": bundleId,
            "_bundle_name": bundleName,
            "_bundle_type": "product-page-bundle-v2",
            "_bundle_role": "addon",
            "_bundle_slot": "2",
            "_bundle_size": getVariantSize(selectedAddonVariant),
            "_bundle_discount_percent": String(discountPercent)
          }
        }
      ];
      

      atc.disabled = true;
      atc.classList.add("is-loading");

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const responseData = await response.json().catch(() => ({}));
          throw new Error(responseData.description || "Could not add bundle to cart.");
        }

        window.location.href = "/cart";
      } catch (error) {
        showError(error.message || "Could not add bundle to cart.");
      } finally {
        atc.classList.remove("is-loading");
        updateAtcState();
      }
    }

    function refreshFromMainProduct() {
      selectedCurrentVariant = getCurrentVariantFromMainProduct();

      renderCurrentItem();
      syncAddonSizeWithCurrent();
      renderAddonSizes();
      updateAddonVariant();
      updatePrices();
      updateAtcState();
      clearError();
    }

    function bindMainProductSync() {
      const form = getMainProductForm();
      const variantInput = getMainVariantInput();

      document.addEventListener("change", (event) => {
        if (root.contains(event.target)) return;

        window.setTimeout(refreshFromMainProduct, 80);
        window.setTimeout(refreshFromMainProduct, 250);
      }, true);

      document.addEventListener("click", (event) => {
        if (root.contains(event.target)) return;

        window.setTimeout(refreshFromMainProduct, 80);
        window.setTimeout(refreshFromMainProduct, 250);
      }, true);

      if (form) {
        form.addEventListener("variant:change", () => {
          window.setTimeout(refreshFromMainProduct, 80);
          window.setTimeout(refreshFromMainProduct, 250);
        }, true);
      }

      if (variantInput) {
        const observer = new MutationObserver(() => {
          window.setTimeout(refreshFromMainProduct, 40);
        });

        observer.observe(variantInput, {
          attributes: true,
          attributeFilter: ["value"]
        });
      }

      window.addEventListener("popstate", refreshFromMainProduct);
    }

    if (atc) {
      atc.addEventListener("click", addBundleToCart);
    }

    selectedCurrentVariant = getCurrentVariantFromMainProduct();

    bindMainProductSync();
    renderCurrentItem();
    renderAddonProducts();
    syncAddonSizeWithCurrent();
    renderAddonSizes();
    updateAddonVariant();
    updatePrices();
    updateAtcState();
  }

  document.querySelectorAll("[data-pack-builder-v2]").forEach(initPackBuilderV2);

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("[data-pack-builder-v2]").forEach(initPackBuilderV2);
  });
})();